import React, { memo, useContext, useState } from "react";

import {
  useGridSelector,
  gridFilteredSortedRowEntriesSelector,
} from "@mui/x-data-grid-pro";

import ProfileModalBody from "./ProfileModalBody";
import { FilterContext } from "context/FilterContext";
import ProfileModalHeader from "./ProfileModalHeader";
import { UserContext } from "context/UserContext";

const ProfileModalContent = ({
  current = {},
  jobInfo,
  title = "",
  apiRef = null,
  closeModal = () => {},
  isCandidatesAccess = false,
}) => {
  const { isInternalUser, Clients, isPresentationEnabled } =
    useContext(FilterContext);
  const { loggedInUserData, userGroup } = useContext(UserContext);
  const rows = useGridSelector(apiRef, gridFilteredSortedRowEntriesSelector);
  const reportsData = rows?.map((el) => el.model);

  const [currentIndex, setCurrentIndex] = useState(
    reportsData?.findIndex((el) => el.id === current.id)
  );
  const [currentData, setCurrentData] = useState(current);

  return (
    <div>
      <ProfileModalHeader
        isInternalUser={isInternalUser}
        title={title}
        currentData={currentData}
        setCurrentData={setCurrentData}
        currentIndex={currentIndex}
        setCurrentIndex={setCurrentIndex}
        closeModal={closeModal}
        reportsData={reportsData}
        isCandidatesAccess={isCandidatesAccess}
        isObfuscated={currentData.is_obfuscated}
      />
      <ProfileModalBody
        data={currentData}
        jobInfo={jobInfo}
        pageNo={currentIndex}
        isInternalUser={isInternalUser}
        isCandidatesAccess={isCandidatesAccess}
        isPresentationEnabled={isPresentationEnabled}
        Clients={Clients}
        loggedInUserData={loggedInUserData}
        userGroup={userGroup}
        apiRef={apiRef}
      />
    </div>
  );
};

export default memo(ProfileModalContent);
